// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Formik, Form } from "formik";
import { actions } from "store/reducers/myProfile";
import { toast } from "react-toastify";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useDispatch, useSelector } from "react-redux";
import FormField from "components/FormField";
import validations from "./schemas/validations";
import formSchema from "./schemas/form";
import initialValues from "./schemas/initialValues";

function ChangePassword() {
  const dispatch = useDispatch();
  const { validationErrors } = useSelector((state) => state.forms);
  const { formId, formField } = formSchema;
  const { oldPassword, password, confirmPassword } = formField;
  const passwordRequirements = [
    "One special characters",
    "Min 6 characters",
    "One number (2 are recommended)",
    "Change it often",
  ];

  const submitForm = async (values) => {
    if (!validationErrors) {
      dispatch(
        actions.changePasswordRequest(
          values.oldPassword,
          values.password,
          values.confirmPassword,
          (err) => toast.error(err),
          () => {
            toast.success("Password changed successfully");
          }
        )
      );
    }
  };

  const renderPasswordRequirements = passwordRequirements.map((item, key) => {
    const itemKey = `element-${key}`;

    return (
      <MDBox key={itemKey} component="li" color="text" fontSize="1.25rem" lineHeight={1}>
        <MDTypography variant="button" color="text" fontWeight="regular" verticalAlign="middle">
          {item}
        </MDTypography>
      </MDBox>
    );
  });

  return (
    <Card id="change-password">
      <MDBox p={3}>
        <MDTypography variant="h5">Change Password</MDTypography>
      </MDBox>
      <MDBox pb={3} px={3}>
        <Formik initialValues={initialValues} validationSchema={validations} onSubmit={submitForm}>
          {({ values, errors, touched, isSubmitting }) => (
            <Form id={formId} autoComplete="new-password">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormField
                    type={oldPassword.type}
                    label={oldPassword.label}
                    name={oldPassword.name}
                    defaultValue={values.oldPassword}
                    placeholder={oldPassword.placeholder}
                    error={errors.oldPassword && touched.oldPassword}
                    success={values.oldPassword.length > 0 && !errors.oldPassword}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormField
                    type={password.type}
                    label={password.label}
                    name={password.name}
                    defaultValue={values.password}
                    placeholder={password.placeholder}
                    error={errors.password && touched.password}
                    success={values.password.length > 0 && !errors.password}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormField
                    type={confirmPassword.type}
                    label={confirmPassword.label}
                    name={confirmPassword.name}
                    defaultValue={values.confirmPassword}
                    placeholder={confirmPassword.placeholder}
                    error={errors.confirmPassword && touched.confirmPassword}
                    success={values.confirmPassword.length > 0 && !errors.confirmPassword}
                  />
                </Grid>
              </Grid>
              <MDBox mt={6} mb={1}>
                <MDTypography variant="h5">Password requirements</MDTypography>
              </MDBox>
              <MDBox mb={1}>
                <MDTypography variant="body2" color="text">
                  Please follow this guide for a strong password
                </MDTypography>
              </MDBox>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="flex-end"
                flexWrap="wrap"
              >
                <MDBox component="ul" m={0} pl={3.25} mb={{ xs: 8, sm: 0 }}>
                  {renderPasswordRequirements}
                </MDBox>
                <MDBox ml="auto">
                  <MDButton
                    disabled={isSubmitting}
                    type="submit"
                    variant="gradient"
                    color="dark"
                    size="small"
                  >
                    Update password
                  </MDButton>
                </MDBox>
              </MDBox>
            </Form>
          )}
        </Formik>
      </MDBox>
    </Card>
  );
}

export default ChangePassword;
